import styled from "styled-components";
import colors from '../../assets/styles/colors';

export const AttachDocumentsContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 44px 20px 15px 20px;
    background: ${colors.bgGray};
`

export const AttachDocumentsContent = styled.div``

export const AttachDocumentsHeader = styled.div``

export const FadeContainer = styled.div`
  transition: ease-in-out .1s;
  opacity: ${prop => prop.fade ? '1' : '0'};
`;

export const AttachDocumentsForm = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 60px;
    height: 90%;
`

export const AttachDocumentsFormItem = styled.div`
    width: 80%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;

    @media (max-width: 1350px) {
        width: 90%;
    }
    
    @media (max-width: 1200px) {
        width: 100%;
    }
`

export const AttachDocumentsFormItemInfo = styled.div`
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-right: 20px;
`

export const AttachDocumentsFormItemTitle = styled.h2`
    color: ${prop => prop.color};
    font-weight: 600;
    margin-bottom: 5px;
`

export const AttachDocumentsFormItemParagraph = styled.p`
    color: ${prop => prop.color};
    margin-bottom: 5px;
`

export const AttachDocumentButton = styled.div`
    width: 10%;
`

export const AttachDocumentLabelFile = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 20px;
    width: 30%;
`

export const AttachDocumentsButtons = styled.div`
    width: 60%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1350px) {
        width: 60%;
    }

    @media (max-width: 1200px) {
        width: 80%;
    }

    @media (max-width: 1000px) {
        width: 90%;
    }
`

export const AttachDocumentsLoaderContainer = styled.div`
    width: 350px;
    height: 15px;
    border-radius: 20px;
    background: ${colors.normalGray};
`

export const AttachDocumentsLoader = styled.div`
    transition: 0.3s;
    width: ${props => props.percentage + '%'};
    border-radius: 20px;
    height: 100%;
    background: ${colors.textHyperlink};
`

export const ParagraphDelete = styled.p`
    font-size: 12px;
    line-height: 17px;
    font-weight: ${prop => prop.bold ? 'bold' : 'normal'};
    color: ${prop => prop.color};
`